var field = {
  width: '100px',
  display: 'inline-block',
  paddingRight: '6px',
  textAlign: 'left'
}

export const data = () => ({
  isDebug: true,
  toggle: false,
  isQuery: false,
  loading: false,
  selectedVendorServiceType: null,
  isFetching: false,
  data: [],
  vendorServiceTypes: [],

  filters: {
    show: false
  },

  pagination: {
    perPage: 10
  },

  columns: [
    {
      field: 'serviceType',
      label: 'Service Type',
      width: '45%',
      sortable: true,
      searchable: true
    },
    {
      field: 'description',
      label: 'Description',
      width: '45%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    formRow: {
      padding: '10px',
      whiteSpace: 'nowrap'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    },
    amountField: Object.assign({}, field, {
      width: '125px'
    })
  }
})
